"use strict";

module.exports = {
    "i-services": {
        "404": "404",
        "adresa": "Мекен-жайлар",
        "advertising": "Жарнама",
        "afisha": "Афиша",
        "all": "Барлық сервистер",
        "api": "API",
        "appmetrica": "AppMetrica",
        "appsearch": "Қосымшалар",
        "audience": "Аудитории",
        "auto": "Авто",
        "autoru": "auto.ru",
        "avia": "Авиабилеттер",
        "aziada": "Азиада",
        "ba": "Баян",
        "backapv": "Партнер Я.Карт",
        "balance": "Баланс",
        "bar": "Бар",
        "bar-ie": "Бар для ИЕ",
        "bar-ie9": "Бар для ИЕ9",
        "bayan": "Яндекстің баннерлері",
        "blogs": "Блоги",
        "books": "Кітаптар",
        "browser": "Браузер",
        "calendar": "Күнтізбе",
        "captcha": "ой...",
        "catalogwdgt": "Каталог виджетов",
        "chrome": "Хром с поиском Яндекса",
        "city": "Қалалар",
        "cityday": "Қала күні",
        "clickhouse": "ClickHouse",
        "collection": "Коллекция",
        "company": "Компания",
        "contest": "Contest",
        "delivery": "Доставка",
        "desktop": "Персональный поиск",
        "direct": "Директ",
        "direct.market": "Маркет",
        "disk": "Диск",
        "display": "Дисплей",
        "ege": "ЕГЭ",
        "expert": "Эксперт",
        "feedback": "Кері байланыс",
        "feedback2": "Кері байланыс",
        "ff": "ФФ с поиском Яндекса",
        "fotki": "Фотолар",
        "fresh": "Соңғы",
        "games": "Ойыншықтар",
        "geocontext": "Геоконтекст",
        "goroda": "Қалалар",
        "help": "Көмек",
        "i": "Менің сервистерім",
        "ie": "ИЕ с поиском Яндекса",
        "images": "Cуреттер",
        "images-com": "Cуреттер",
        "interests": "Қызығушылықтар",
        "internet": "Интернет",
        "kassa": "Касса",
        "keyboard": "Клавиатура",
        "kraski": "Бояулар",
        "kuda": "Бәрі қайда барады",
        "large": "Яндекс для слабовидящих",
        "legal": "Правовые документы",
        "lenta": "Таспа",
        "libra": "Библиотека",
        "literacy": "Неделя борьбы за грамотность",
        "local": "Жергілікті жүйе",
        "lost": "Ұмытылмас",
        "love": "Өзара тартылыс күні — 13 тамыз",
        "mail": "Пошта",
        "maps": "Карталар",
        "maps-wiki": "Народная карта",
        "market": "Маркет",
        "market.advertising": "Маркет",
        "master": "Мастер",
        "metrika": "Метрика",
        "metro": "Метро",
        "mobile": "Мобильді",
        "moikrug": "Мой Круг",
        "money": "Ақша",
        "museums": "Тарихи мәдени мұра күндері",
        "music": "Музыка",
        "music-partner": "Музыка: статистика",
        "nahodki": "Іздестіргендерім",
        "nano": "Нано",
        "newhire": "Наниматор",
        "news": "Жаңалықтар",
        "notifications": "Нотификациялық тақта",
        "oauth": "OAuth",
        "online": "Онлайн",
        "openid": "OpenID",
        "opera": "Opera Software",
        "opinion": "Цитаталар",
        "partners": "Жарнама жүйесі",
        "partnersearch": "Партнерлер үшін іздестіру",
        "passport": "Паспорт",
        "pdd": "Домен үшін пошта",
        "peoplesearch": "Адамдар",
        "perevod": "Аудармашы",
        "probki": "Кептелістер",
        "pulse": "блоги: пульс",
        "punto": "Punto switcher",
        "pvo": "Жауаптар",
        "rabota": "Жұмыс",
        "radar": "Радар",
        "ramazan": "",
        "rasp": "Кестелер",
        "realty": "Жылжымайтын мүлік",
        "referats": "Рефераттар",
        "rk": "Сұрақтар бар?",
        "root": "Unix администраторларға арналған Яндекс.Олимпиада",
        "school": "Школьная морда",
        "search": "Іздестіру",
        "server": "Сервер",
        "shtrafi": "Айыппұлдар",
        "site": "Сайт үшін іздестіру",
        "slovari": "Сөздіктер",
        "so": "Самооборона",
        "social": "Социализм",
        "soft": "Бағдарламалар",
        "sport": "Спорт",
        "sprav": "Анықтағыш",
        "start": "Бастапқы бет",
        "stat": "Статистика",
        "subs": "Жазылымдар",
        "taxi": "Такси",
        "telephony": "Телефония",
        "terms": "Тілашар",
        "tests": "Тесттер мен сұрақтамалар",
        "tickets": "Билеттер",
        "time": "Яндекс.Уақыт",
        "toloka": "Яндекс.Толока",
        "toster": "Тосттар",
        "translate": "Аудармашы",
        "tune": "Баптаулар",
        "tv": "ТД",
        "uslugi": "Услуги",
        "video": "Видео",
        "video-com": "Видео",
        "vno": "СТБ",
        "wdgt": "Виджеттер",
        "weather": "Ауа-райы",
        "webmaster": "Вебмастер",
        "webmaster-api": "API Вебмастера",
        "widgets": "Виджеттер",
        "wordstat": "Статистика",
        "wow": "Я.ру",
        "www": "Іздестіру",
        "xmlsearch": "XML",
        "yaca": "Каталог",
        "yamb": "Медийные баннеры",
        "zakladki": "Закладки"
    }
};